import React from 'react';
import { Input as AntdInput } from 'antd';

const TrimmedInput = (Component) => {
    return ({ onBlur, onChange, ...restProps }) => {
        const handleBlur = (e) => {
            const trimmed = e.target?.value?.trim();
            if (trimmed !== e.target?.value) {
                e.target.value = trimmed;
                onChange?.(e);
            }
            onBlur?.(e);
        };

        return <Component {...restProps} onChange={onChange} onBlur={handleBlur} />;
    };
};

export const Input = TrimmedInput(AntdInput);
Input.Password = TrimmedInput(AntdInput.Password);
Input.TextArea = TrimmedInput(AntdInput.TextArea);
Input.Search = TrimmedInput(AntdInput.Search);
